import { WizCommand, WizRoot } from '@wizeoo/akm-component-lib';
import { DataPack } from '@wizeoo/akm-message-lib';
import { ExternalAPI } from '../../model/external-api';
import { Model } from '../../model/model';

/**
 * Appels du service de check sur les Workcom
 * Author LMA
 */
export class WorkcomCheckCmd extends WizCommand<DataPack> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  }


  public sourcePack: DataPack = null; // les packs transmis au service

  /** check */
  public check(callback: Function): WorkcomCheckCmd {
    this.sourcePack = this.buildPack();
    this.sourcePack.originUuid = WizRoot.getInstance().uuid; // prise de l'origine unique
    this.configureRemote(ExternalAPI.WORKCOM_CHECK_API, this.sourcePack, callback);

    return this;
  }

  /** Execution call
   * @override pour persistence locale des EMs (pour replay sur échec)
   */
  public async execute(): Promise<any> {
    super.execute();
  }

  /**
   * utilisation du lock, ou pas (pas de lock si silent = true)
   * Attention, écrasé par commit (qui fait un configure), donc l'appeler APRES
   */
  public silent(silent: boolean = true): WorkcomCheckCmd {
    this.doLock = !silent;
    return this;
  }

  /** construction du pack remote */
  private buildPack(): DataPack {
 
    let result: DataPack = new DataPack();

    result.domain = this.model.domainCode;
    result.businessUnitCode = this.model.businessUnitCode;
    result.visionCode = this.model.visionCode;
    result.login = this.model.connectedUser.mail;
    result.originUuid = WizRoot.getInstance().uuid;
    result.datas = {};

    /* ################################################
        gestion des freedatas
      ################################################ */

    // numRev pour les FDs
    result.workcomRevisionNumber = this.model.workcomSyncService.dataload.revisionNumber;

    return result;
  }


  /** sur retour, traitement selon la méthode */
  public wizResult() {
    this.sourcePack = this.result;
    super.wizResult();
  }
}
